export default {
    title: "Strona nie została znaleziona",
    description:
        "Być może strona już nie istnieje lub wpisany został błędny adres.<br/>Skorzystaj z naszej wyszukiwarki lub przejdź do strony głównej i spróbuj raz jeszcze.",
    button: "Strona główna",
};
